"use client";

import Grid from "@mui/material/Grid2";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import { SubscribeMessages } from "@/messages/subscribe/subscribe.messages";

import ProductInfoCard from "./components/ProductInfoCard";
import SubscribeFormCard from "./components/SubscribeFormCard";

type Props = {
  messages: SubscribeMessages;
  isLoading: boolean;
};

export default function SubscribeForm({ messages, isLoading }: Props) {
  return (
    <MDBox>
      <MDBox my={3}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, lg: 5 }}>
            <MDBox height={"100%"}>
              <ProductInfoCard messages={messages} />
            </MDBox>
          </Grid>
          <Grid size={{ xs: 12, lg: 7 }}>
            <MDBox height={"100%"}>
              <SubscribeFormCard messages={messages} isLoading={isLoading} />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}
